"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _ReviewAxes = require("../constants/reviews/ReviewAxes");

var _ReviewsListQueries = require("../constants/reviews/ReviewsListQueries");

var defaults = {
  count: null,
  axes: new _immutable.Map()
};

var ReviewStats = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(ReviewStats, _Record);

  function ReviewStats() {
    (0, _classCallCheck2.default)(this, ReviewStats);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReviewStats).apply(this, arguments));
  }

  (0, _createClass2.default)(ReviewStats, [{
    key: "getOverallPercentages",
    value: function getOverallPercentages() {
      var overall = this.axes.get(_ReviewAxes.ReviewAxes.OVERALL);

      if (!overall || !overall.get('distribution')) {
        return null;
      }

      var sum = overall.get('distribution').reduce(function (acc, val) {
        acc += val;
        return acc;
      }, 0);
      var acc = 0;
      return overall.get('distribution').map(function (count, key) {
        if (key === '5') {
          // Ensures that percentages add up to 100
          return 100 - acc;
        }

        var percentage = Math.round(count * 100 / sum);
        acc += percentage;
        return percentage;
      });
    }
  }, {
    key: "getQualityRatings",
    value: function getQualityRatings() {
      var qualityRatingsMap = this.axes.delete(_ReviewAxes.ReviewAxes.OVERALL).map(function (axisMap) {
        return axisMap.get('average');
      });
      return _ReviewAxes.QualityRatingsTemplate.merge(qualityRatingsMap);
    }
  }, {
    key: "getAxisAverage",
    value: function getAxisAverage(axis) {
      return this.axes.getIn([axis, 'average']);
    }
  }, {
    key: "getValidRatingFilters",
    value: function getValidRatingFilters() {
      return this.axes.getIn([_ReviewAxes.ReviewAxes.OVERALL, 'distribution']).filter(function (count) {
        return count;
      }).mapKeys(function (rating) {
        return _ReviewsListQueries.STAR_NUM_TO_STATE.get(rating);
      });
    }
  }], [{
    key: "from",
    value: function from(data) {
      return new ReviewStats((0, _immutable.fromJS)(data));
    }
  }]);
  return ReviewStats;
}((0, _immutable.Record)(defaults));

exports.default = ReviewStats;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/records/ReviewStats.js
// module id = 127
// module chunks = 209 210 211 212